import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isOrgAccountActive } from "../../api/localstorage_api";
import { useAppContext } from "../../libs/contextLib";
import { isUserSignUpComplete, usePageTitle } from "../../libs/hooksLib";
import { useUser } from "../../libs/apiHooksLib";
import PlaceholderPage from "../layout/PlaceholderPage";

export default function CandidateAuthenticatedRoute({ children, showLoginNav = true, title = null, ...rest }) {
  const { pathname, search } = useLocation();
  const { isAuthenticated } = useAppContext();
  const { setShowLoginNav } = useAppContext();
  const {user} = useUser();

  usePageTitle(title);
  useEffect(() => {
    setShowLoginNav(showLoginNav);
  });

  if(isAuthenticated){
    if(!isOrgAccountActive()){
      if(isUserSignUpComplete(isAuthenticated, user)){
        return children;
      }else{
        <Navigate replace to={`/signup?redirect=${pathname}${search}`} />;
      }
    }else{
      return (
        <PlaceholderPage>
          <h1>Sorry! This is a candidate only page, please log out of your organisation account to view.</h1>
        </PlaceholderPage>
      );
    }
  }else{
    <Navigate replace to={`/signup?redirect=${pathname}${search}`} />
  }
}